import { render, staticRenderFns } from "./TeleMedicines.vue?vue&type=template&id=59246a00&scoped=true"
import script from "./TeleMedicines.vue?vue&type=script&lang=js"
export * from "./TeleMedicines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59246a00",
  null
  
)

export default component.exports